import axios from '@/utils/request'

/**
 * 轮播图列表
 */
const getCarouselList = (params, options) => axios({
  url: 'base/banner',
  params,
  options
})

/**
 * 删除轮播图
 */
const deleteCarouse = (uuid) => axios({
  url: `base/banner/${uuid}`,
  method: 'delete'
})

/**
 * 编辑轮播图
 */
const setCarouse = (data) => axios({
  url: 'base/banner',
  method: 'put',
  data
})

/**
 * 新增轮播图
 */
const addCarouse = (data) => axios({
  url: 'base/banner',
  method: 'post',
  data
})

/**
 * 获取导航设置（ip）
 */
const getLatLng = () => axios({
  url: 'base/navigation'
})

/**
 * 编辑导航设置
 */
const putLatLng = (data) => axios({
  url: 'base/navigation',
  method: 'put',
  data
})

/**
 * 获取咨询列表
 * @param {pageSize}
 * @param {pageIndex}
 * @param {industryUuid}
 */
export const getConsultList = (params) => axios({
  url: 'base/information',
  params
})

/**
 * 添加咨询列表
 * @param {content}
 * @param {industryUuid}
 * @param {startTime}
 */
export const addConsult = (data) => axios({
  url: 'base/information',
  method: 'post',
  data
})

/**
 * 删除咨询列表
 * @param {uuid}
 */
export const deleteConsult = (id) => axios({
  url: `base/information/${id}`,
  method: 'delete'
})

/**
 * 更新资讯是否显示状态
 * @param {uuid}
 */
export const setConsult = (id) => axios({
  url: `base/information/${id}`,
  method: 'put'
})

/**
 * 资讯详情
 * @param {uuid}
 */
export const getConsultDetail = (uuid) => axios({
  url: `base/information/${uuid}`,
  method: 'get'
})

/**
 * 更新资讯是否显示状态
 * @param {content}
 * @param {industryUuid}
 * @param {startTime}
 */
export const updateConsult = (data) => axios({
  url: 'base/information',
  method: 'put',
  data
})

/**
 * 更改轮播图是否显示状态
 */
export const updateCarouse = (uuid) => axios({
  url: `base/banner/${uuid}`,
  method: 'put'
})

export {
  getCarouselList,
  deleteCarouse,
  setCarouse,
  addCarouse,
  getLatLng,
  putLatLng
}
